import { pdfjs } from 'react-pdf'
import pdfWorkerUrl from 'pdfjs-dist/legacy/build/pdf.worker.min.mjs?url'

// WHY: pdfjs 5 系の worker は .mjs で、CDN 上のファイル名も版ごとに変わるため CDN 参照をやめ、
// バンドル同梱にする（実行時に第三者 CDN から worker を取ってくる依存も断てる）。
// WARNING: legacy build を指定している。worker は ?url でアセットとして出るだけで
// browserslist に沿った transpile を受けず、modern build は Promise.withResolvers 等
// （Safari 17.4+）をそのまま呼ぶため、古い端末で PDF が開かなくなる。
// メインスレッド側も vite.config.mts の resolve.alias で legacy に寄せてある。
// 片方だけ legacy にしても意味がないので、変えるときは両方セットで。TB-2418
pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl
